<template>
  <div>
    <countdown v-if="currentStage === 'countdown'" @startGame="startGame" />
    <puzzle
      v-if="currentStage === 'puzzle'"
      :number="puzzleNumber"
      :name="`/updown/${puzzleNumber}.png`"
      :options="['Up', 'Down', 'Up then Down', 'Down then Up']"
      :largeButtons="true"
      :keyboard="false"
      :startingTime="60"
      :beepCountdown="true"
      @complete="puzzleComplete"
    />
    <pause
      v-if="currentStage === 'pause'"
      :solution="solution[puzzleNumber - 1]"
      :legCorrect="lastLegCorrect"
      @nextPuzzle="nextPuzzle"
    />
    <game-over
      v-if="currentStage === 'gameover'"
      :user="''"
      :time="userTime"
      :score="userScore"
    />
  </div>
</template>

<script>
import Countdown from '@/components/Countdown'
import Puzzle from '@/components/PuzzleSmall'
import Pause from '@/components/Pause'
import GameOver from '@/components/GameOver'

export default {
  components: {
    Countdown,
    Puzzle,
    Pause,
    GameOver,
  },

  data: function() {
    return {
      puzzleNumber: 1,
      currentStage: 'countdown',
      choices: [],
      times: [],
      userScore: '',
      userTime: 0,
      solution: ['Up', 'Up then Down', 'Up', 'Up then Down', 'Down then Up'],
    }
  },

  computed: {
    lastLegCorrect: function() {
      return (
        this.solution[this.puzzleNumber - 1] ===
        this.choices[this.puzzleNumber - 1]
      )
    },
  },

  methods: {
    startGame: function() {
      this.currentStage = 'puzzle'
    },

    puzzleComplete: function(result) {
      this.choices.push(result.choice)
      this.times.push(result.time)

      this.currentStage = 'pause'
    },

    nextPuzzle: function() {
      if (this.puzzleNumber === this.solution.length) {
        this.currentStage = 'gameover'

        this.userScore = this.scoreUser()
        this.userTime = this.times.reduce((a, b) => a + b, 0)
      } else {
        this.puzzleNumber += 1
        this.currentStage = 'puzzle'
      }
    },

    scoreUser: function() {
      let correct = 0
      for (const choice in this.choices) {
        if (this.solution[choice] === this.choices[choice])
          correct += 60 - Math.round(this.times[choice] / 1000)
      }

      return `${correct}`
    },
  },
}
</script>
